export default __webpack_public_path__ + "static/media/36_4_0.22720013.png";